export default __webpack_public_path__ + "static/media/What we do-eachpage-Branding & Graphic_Design.7eb92d23.png";